import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentService } from './document.service';
import {
  ERP_WORKFLOW_STATUT,
  resolveTransferWorkflowRootId,
} from './stock-transfer-workflow.util';
import { STOCK_TRANSFER_WORKFLOW_TYPE_IDS } from './stock-transfer-workflow.constants';

/** Id racine workflow pour le BT issu d'un PV (PV lui-même ou document_original_id). */
export function resolvePvEcartBonTransfertWorkflowRootId(
  pvDoc: Record<string, unknown> | null | undefined,
  pvDocumentId: number
): number {
  const fromUtil = resolveTransferWorkflowRootId(pvDoc);
  if (fromUtil != null && fromUtil > 0) {
    return fromUtil;
  }
  const oid = Number(pvDoc?.['document_original_id'] ?? 0);
  if (Number.isFinite(oid) && oid > 0) {
    return oid;
  }
  return pvDocumentId;
}

export function extractNewDocumentIdFromDuplicateResponse(res: unknown): number | null {
  const r = res as Record<string, unknown> | null | undefined;
  const data = (r?.['data'] as Record<string, unknown>) ?? r;
  const doc = (data?.['document'] as Record<string, unknown>) ?? data;
  const raw = doc?.['id'] ?? data?.['id'] ?? r?.['id'];
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Duplication PV d'écart → bon de transfert (brouillon), données copiées depuis le PV.
 */
export function convertPvEcartToBonTransfert$(
  documentService: DocumentService,
  pvDocumentId: number,
  pvDoc?: Record<string, unknown> | null
): Observable<{ newBtId: number; refExterne: string | null }> {
  const rootId = resolvePvEcartBonTransfertWorkflowRootId(pvDoc ?? null, pvDocumentId);
  return documentService
    .convertDocumentType(
      pvDocumentId,
      STOCK_TRANSFER_WORKFLOW_TYPE_IDS.BON_TRANSFERT,
      ERP_WORKFLOW_STATUT.BROUILLON,
      rootId,
      undefined,
      'BON_TRANSFERT'
    )
    .pipe(
      map((res) => {
        const newBtId = extractNewDocumentIdFromDuplicateResponse(res);
        if (!newBtId) {
          throw new Error('Bon de transfert non créé (identifiant absent dans la réponse).');
        }
        const data = (res as { data?: { document?: { ref_externe?: string } } })?.data;
        const refExterne =
          data?.document?.ref_externe != null
            ? String(data.document.ref_externe).trim()
            : null;
        return { newBtId, refExterne };
      })
    );
}
